import { HttpClient } from '@adapters/HttpClient';
import {
  ManifestPreviewResponse,
  Manifest,
  PreviewManifestRequest,
  GenerateManifestRequest,
} from '../models/Manifest';

export class ManifestApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async preview(request: PreviewManifestRequest): Promise<ManifestPreviewResponse> {
    return await this.httpClient.get<ManifestPreviewResponse>(
      '/manifests/preview',
      { courier_integration_id: request.courier_integration_id }
    );
  }

  async generate(request: GenerateManifestRequest): Promise<Manifest> {
    return await this.httpClient.post<Manifest>('/manifests', request);
  }

  async uploadSignedPdf(manifestId: number, file: File): Promise<Manifest> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return await this.httpClient.post<Manifest>(
      `/manifests/${manifestId}/signed-pdf`,
      formData,
      true,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
  }

  async complete(manifestId: number): Promise<Manifest> {
    return await this.httpClient.put<Manifest>(
      `/manifests/${manifestId}/complete`,
      {}
    );
  }
}
